/* eslint-disable react/jsx-props-no-spreading,import/prefer-default-export */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';

import { useHistory } from 'react-router-dom';
import { formatNumber, formatNumberWithComma } from '../../../../../utilities/formatHelpers';
import { currencies, exchange } from '../../../../../utilities/constants';
import {
  SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
  USER_PREFERENCES,
} from '../../../../../utilities/sharedQueries';
import { useCurrency } from '../../../../../utilities/sharedHooks/settings';
import CurrencyIcon from '../../../../../components/CurrencyIcon';
import { useLedgerFilteredCurrencies } from '../../../../../utilities/sharedHooks/ledgerWallets';
import { walletCurrenciesTypes } from '../../../../../screens/Accounts/constants';

export const Wallet = ({
  wallet,
  ledgerAccount = null,
  onDepositClick,
  onWithdrawalClick,
  onSendClick,
  isExchangeDisabled,
  onExchangeClick,
  selectedWalletType,
  isReceiveDisabled,
  isDepositHidden,
  isSendDisabled,
  className = '',
}) => {
  const history = useHistory();
  const { t: translate } = useTranslation();
  const {
    available_balance: availableBalance,
    rate,
    change,
    fiat_balance: fiatBalanceWallet,
  } = wallet;
  const { data: userPref } = useQuery(USER_PREFERENCES);
  const fiatCurrencyCode = userPref?.displayCurrency || 'EUR';
  const currency = currencies[wallet.coin];
  const currencyData = useCurrency(wallet.coin);

  const { data: ledgerFilteredCurrencies } = useLedgerFilteredCurrencies([
    SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
  ]);

  const isStableCoin = useMemo(() => {
    if (ledgerFilteredCurrencies) {
      return ledgerFilteredCurrencies[wallet.coin]?.fiat_currency_peg;
    }
    return null;
  }, [ledgerFilteredCurrencies, wallet.coin]);

  const isRateLessThanOne = parseFloat(rate) <= 1;
  const walletBalance = formatNumber(availableBalance * currency.conversion, currency.decimal);
  const currencyBalanceLabel = `${walletBalance} ${wallet.coin}`;
  const fiatBalance = formatNumberWithComma(formatNumber(fiatBalanceWallet, exchange.FIAT_VALUE));
  const fiatBalanceLabel = `${fiatBalance} ${fiatCurrencyCode}`;

  const currencyFiatValueLabel = `${formatNumber(
    rate,
    isRateLessThanOne ? exchange.FIAT_LESS_ONE_VALUE : exchange.FIAT_VALUE
  )} ${fiatCurrencyCode}`;

  const Menu = ({ children, ...props }) => {
    const { innerProps } = props;
    return (
      <div
        style={{
          zIndex: 2,
          top: 'calc(100% + 0.688rem)',
          minWidth: '9.063rem',
        }}
        className="select_menu-container bg-white py-1 text-left rounded shadow-lg position-absolute end-0 my-0 mx-auto text-left"
        {...innerProps}>
        {children}
      </div>
    );
  };

  Menu.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object]).isRequired,
    innerProps: PropTypes.oneOfType([PropTypes.object]).isRequired,
  };

  const isCryptoWallet = wallet.wallet_type.toLowerCase() === walletCurrenciesTypes.CRYPTO;
  const renderCryptoActionButtons = () => (
    <div className="flex-even d-flex flex-row align-items-center justify-content-end">
      {!isDepositHidden && (
        <>
          <button
            onClick={() => {
              onDepositClick();
            }}
            disabled={isReceiveDisabled}
            type="button"
            className="btn text-primary rounded-3 p-0 text-f6 m-0 text-nowrap text-btn-item border-0">
            <b>{translate('add_funds_btn_title')}</b>
          </button>
          <b className="text-f5 text-disabled mx-3">|</b>
        </>
      )}
      <button
        type="button"
        className="btn text-primary rounded-3 p-0 text-f6 m-0 text-btn-item border-0"
        disabled={isSendDisabled}
        onClick={onSendClick}>
        <b>{translate('send_button_label')}</b>
      </button>
      <b className="text-f5 text-disabled mx-3">|</b>
      <button
        type="button"
        disabled={isExchangeDisabled}
        className={`btn text-btn-item border-0 ${
          isExchangeDisabled ? 'text-disabled' : 'text-primary'
        } rounded-3 p-0 text-f6 m-0`}
        onClick={onExchangeClick}>
        <b>{translate('exchange_button_label')}</b>
      </button>
    </div>
  );

  const renderFiatActionButtons = () => (
    <div className="flex-even d-flex flex-row align-items-center justify-content-end">
      {!isDepositHidden && (
        <>
          <button
            onClick={() => {
              onDepositClick();
            }}
            type="button"
            disabled={isReceiveDisabled}
            className="btn text-primary rounded-3 text-f6 m-0 p-0 text-nowrap text-btn-item border-0">
            <b>{translate('add_funds_btn_title')}</b>
          </button>
          <b className={`text-f5 text-disabled ${isStableCoin ? 'ms-3' : 'mx-3'}`}>|</b>
        </>
      )}
      <button
        disabled={isSendDisabled}
        onClick={isStableCoin ? onSendClick : onWithdrawalClick}
        type="button"
        className={`btn text-primary rounded-3 text-f6 m-0 p-0 text-btn-item border-0 ${
          isStableCoin ? 'mx-4 ps-1 pe-1' : ''
        }`}>
        <b>{isStableCoin ? translate('send_button_label') : translate('withdraw_button_label')}</b>
      </button>
      <b className={`text-f5 text-disabled ${isStableCoin ? 'me-3' : 'mx-3'}`}>|</b>
      <button
        type="button"
        disabled={isExchangeDisabled}
        className={`btn text-btn-item border-0 ${
          isExchangeDisabled ? 'text-disabled' : 'text-primary'
        } rounded-3 p-0 text-f6 m-0`}
        onClick={onExchangeClick}>
        <b>{translate('exchange_button_label')}</b>
      </button>
    </div>
  );

  const Control = ({ children, ...props }) => {
    const { innerProps } = props;
    return (
      <div className="bg-transparent border-0" {...innerProps}>
        {children}
      </div>
    );
  };

  Control.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    innerProps: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  };

  const renderButtons = () =>
    isCryptoWallet ? renderCryptoActionButtons() : renderFiatActionButtons();

  const getInnerItem = () => (
    <>
      <div
        className="col col-md-3 d-flex flex-row align-items-center justify-content-start text-start link-block ps-0"
        role="button"
        tabIndex={0}
        onClick={() => {
          history.push(`/dashboard/accounts/${wallet.coin}/details`, {
            ledgerAccount,
            wallet,
          });
        }}
        onKeyDown={() => {}}>
        <CurrencyIcon
          currencyCode={wallet?.coin}
          style={{
            width: '1.5rem',
            height: '1.5rem',
            ...(wallet?.coin?.toUpperCase() === currencies.XRP.icon
              ? {
                  backgroundColor: 'white',
                  padding: '1px',
                  borderRadius: '20px',
                }
              : {}),
          }}
        />
        <div className="ms-3">
          <b className="upper-case">{wallet.coin}</b>
          <p className="d-none d-md-block text-shadow text-f6 link-text">
            {currencyData?.currency_name}
          </p>
          <p className="d-block d-md-none text-shadow text-f6 link-text">
            {currencyFiatValueLabel}
          </p>
        </div>
      </div>

      <div className="col d-flex flex-column text-end text-md-start px-0">
        <b className="upper-case">{currencyBalanceLabel}</b>
        <p className="text-shadow text-f6">{fiatBalanceLabel}</p>
      </div>

      {selectedWalletType === 'crypto' && (
        <div className="col d-flex flex-row align-items-start justify-content-start text-start d-none d-md-block col-2">
          <b>{currencyFiatValueLabel}</b>
          {change && change !== '-' && (
            <p className={`text-f6 ${change > 0 ? 'text-success' : 'text-danger'}`}>
              {change > 0 ? '+' : ''}
              {change}%
            </p>
          )}
        </div>
      )}
      <div className="d-none d-md-flex col flex-row align-items-center justify-content-center position-relative col-4 pe-0">
        {renderButtons()}
      </div>
    </>
  );
  return (
    <div className={`container-fluid rounded-3 p-0 ${className ?? ''}`}>
      <div
        data-testid="account-item"
        className="row d-none d-md-flex flex-row align-items-center bg-lighter rounded-3 py-3 mx-0 justify-content-between"
        style={{ padding: '0 1.5rem' }}>
        {getInnerItem()}
      </div>
      <div
        data-testid="account-item"
        className="row d-flex d-md-none flex-row align-items-center bg-lighter rounded-3 py-3 mx-0 justify-content-between"
        style={{ padding: '0 1rem' }}
        role="button"
        tabIndex={0}
        onClick={() => {
          history.push(`/dashboard/accounts/${wallet.coin}/details`, {
            ledgerAccount,
            wallet,
          });
        }}
        onKeyDown={() => {}}>
        {getInnerItem()}
      </div>
    </div>
  );
};
Wallet.propTypes = {
  wallet: PropTypes.object.isRequired,
  onDepositClick: PropTypes.func.isRequired,
  onWithdrawalClick: PropTypes.func.isRequired,
  onSendClick: PropTypes.func.isRequired,
  ledgerAccount: PropTypes.object,
  isExchangeDisabled: PropTypes.bool.isRequired,
  onExchangeClick: PropTypes.func.isRequired,
  selectedWalletType: PropTypes.string.isRequired,
  isReceiveDisabled: PropTypes.bool.isRequired,
  isDepositHidden: PropTypes.bool.isRequired,
  isSendDisabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
};
